import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "@/components/Theme";
import Para from "@/atoms/text/Para";
import {
  HouseWithTwoTreesIcon,
  TwoTreesIcon,
  TwoHousesWithTreeIcon,
  HouseWithFourTreesIcon,
  TreesFilledIcon,
} from "@/atoms/Icons";
import { isMobileScreen } from "@/utils/functions";
import useIntersectionObserver from "@/utils/useIntersectionObserver";

export function TreeCountSection() {
  const [isMobile, setIsMobile] = useState(null);
  const context = useContext(GlobalContext);
  const treeCount = context?.[2];
  const { elementRef: firstElementRef, isIntersecting: isFirstIntersecting } =
    useIntersectionObserver({
      threshold: 0.1,
    });

  const { elementRef: secondElementRef, isIntersecting: isSecondIntersecting } =
    useIntersectionObserver({
      threshold: 0.1,
    });

  const treeCountArray = String(treeCount).split("");

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <section className="bc-black tc-white pt-10 pb-8-d pb-4 ta-center-d">
      <div className="container">
        <Para color="white" desktopSize="lg" mobileSize="md" className="mb-5">
          We are planting a tree
          <br className="desktop-hide" /> for every customer, every month.
        </Para>
        <div
          className="tree-count-wrapper title title--xl-d title--sm mb-5"
          ref={firstElementRef}
        >
          <TreesFilledIcon
            transformTree={
              isSecondIntersecting ? "translate(0 0)" : "translate(0 60)"
            }
            transitionDelayTree="transition-delay-1800"
            className="ps-r bottom-5"
            width={isMobile ? "38" : "54"}
          />
          &nbsp;
          <strong className="tree-num">
            {treeCountArray.map((char, index) => (
              <span
                key={`tree-list-${index}`}
                className={`digit ${isFirstIntersecting ? "animate" : ""}`}
                style={{
                  "--delay": `${(
                    (treeCountArray.length - 1 - index) *
                    0.2
                  ).toFixed(1)}s`,
                }}
              >
                {char}
              </span>
            ))}
          </strong>
          <strong className="title title--xl-d title--sm">&nbsp;trees</strong>
        </div>
        <a
          href="/giving-back"
          className="btn btn--link btn--link-lg mb-7-d mb-10"
        >
          Grow with us
        </a>
        <figure
          className="ps-r img-wrapper fx fx--sb fx--fe"
          ref={secondElementRef}
        >
          <HouseWithTwoTreesIcon className="phone-hide" />
          <TwoTreesIcon
            className="mini-phone-hide"
            transformTree1={
              isSecondIntersecting ? "translate(40 20)" : "translate(40 40)"
            }
            transitionDelayTree1="transition-delay-400"
            transformTree2={
              isSecondIntersecting ? "translate(0 0)" : "translate(0 40)"
            }
            transitionDelayTree2="transition-delay-600"
          />
          <HouseWithFourTreesIcon
            transformTree1={
              isSecondIntersecting ? "translate(0 0)" : "translate(0 60)"
            }
            transitionDelayTree1="transition-delay-1400"
            transformTree2={
              isSecondIntersecting ? "translate(160 20)" : "translate(160 60)"
            }
            transitionDelayTree2="transition-delay-1200"
            transformTree3={
              isSecondIntersecting ? "translate(200 0)" : "translate(200 60)"
            }
            transitionDelayTree3="transition-delay-1000"
            transformTree4={
              isSecondIntersecting ? "translate(240 20)" : "translate(240 60)"
            }
            transitionDelayTree4="transition-delay-800"
          />
          <TwoTreesIcon
            className="mini-phone-hide aestheticBg-flip"
            transformTree1={
              isSecondIntersecting ? "translate(40 20)" : "translate(40 40)"
            }
            transitionDelayTree1="transition-delay-400"
            transformTree2={
              isSecondIntersecting ? "translate(0 0)" : "translate(0 40)"
            }
            transitionDelayTree2="transition-delay-600"
          />
          <TwoHousesWithTreeIcon className="phone-hide" />
        </figure>
      </div>
      <style jsx>{`
        .digit {
          display: inline-block;
          font-weight: bold;
          transform: translateY(100%);
          opacity: 0;
          transition: transform 0.3s ease var(--delay),
            opacity 0.3s ease var(--delay);
        }
        .digit.animate {
          transform: translateY(0);
          opacity: 1;
        }
        .btn--link {
          color: #fff;
        }
        .btn--link::after {
          filter: initial;
        }
        .img-wrapper::after {
          content: "";
          position: absolute;
          inset: auto 0 0 0;
          height: 2px;
          background-color: #fff;
        }
        .tree-num {
          letter-spacing: 3.6px;
        }
        @media screen and (min-width: 750px) {
          .tree-count-wrapper {
            height: 70px;
            overflow: hidden;
          }
        }
        @media screen and (max-width: 749px) {
          .img-wrapper {
            justify-content: center;
          }
        }
      `}</style>
    </section>
  );
}
